"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPinnedEngagement = getPinnedEngagement;
exports.unpinEngagement = unpinEngagement;
exports.pinEngagement = pinEngagement;
exports.replacePinnedEngagement = replacePinnedEngagement;

var _PinnedEngagementActionTypes = require("crm_ui/pinnedEngagements/actions/PinnedEngagementActionTypes");

var _dispatch = require("crm_data/flux/dispatch");

var PinnedEngagementsAPI = _interopRequireWildcard(require("crm_data/engagements/api/PinnedEngagementsAPI"));

var _immutable = require("immutable");

var _ActionTypes = require("crm_data/actions/ActionTypes");

var _LoadingStatus = require("crm_data/constants/LoadingStatus");

var savePinnedEngagement = function savePinnedEngagement(subjectId, objectType, timelineItem) {
  var engagementId = timelineItem.getIn(['eventData', 'engagement', 'id']);
  PinnedEngagementsAPI.save(objectType, subjectId, engagementId).then(function () {
    (0, _dispatch.dispatch)(_PinnedEngagementActionTypes.PIN_ENGAGEMENT, {
      objectType: objectType,
      subjectId: subjectId,
      timelineItem: timelineItem,
      engagementId: engagementId
    });
  }).done();
};

function getPinnedEngagement(objectType, subjectId) {
  return PinnedEngagementsAPI.fetch(objectType, subjectId).then(function (response) {
    if (!response) {
      return _LoadingStatus.EMPTY;
    }

    var engagementId = response.getIn(['engagement', 'id']);
    (0, _dispatch.dispatch)(_ActionTypes.ENGAGEMENTS_UPDATED, (0, _immutable.Map)().set("" + engagementId, response));
    (0, _dispatch.dispatch)(_PinnedEngagementActionTypes.SET_PINNED_ENGAGEMENT_ID, {
      subjectId: subjectId,
      engagementId: engagementId
    });
    return engagementId;
  });
}

function unpinEngagement(subjectId, objectType, timelineItem) {
  return PinnedEngagementsAPI.unpin(objectType, subjectId).then(function () {
    (0, _dispatch.dispatch)(_PinnedEngagementActionTypes.UNPIN_ENGAGEMENT, {
      objectType: objectType,
      subjectId: subjectId,
      timelineItem: timelineItem
    });
  }).done();
}

function pinEngagement(objectType, subjectId, timelineItem) {
  return savePinnedEngagement(subjectId, objectType, timelineItem);
}

function replacePinnedEngagement(objectType, subjectId, oldTimelineItem, newTimelineItem) {
  (0, _dispatch.dispatch)(_PinnedEngagementActionTypes.UNPIN_ENGAGEMENT, {
    objectType: objectType,
    subjectId: subjectId,
    timelineItem: oldTimelineItem
  });
  return pinEngagement(objectType, subjectId, newTimelineItem);
}